// サムネイル画像表示・サムネイル画像のタイル
$(document).ready(function () {
    const $roomModals = $('.room-modal');
    $roomModals.each((index, element) => {
        var mainImg = $("<img>").hide(),
            mainView = $(".room-imageareain", element).append(mainImg);
        var areaHeight = $(".room-imagearea", element).height(),
            areaWidth = $(".room-imagearea", element).width(),
            areaRatio = areaHeight / areaWidth;
        var $imageThumnail = $(".room-image-thumnail", element);
        var isLoading = false;
        var imageIndex = 0;
        var fadeInTime = 100,
            fadeOutTime = 100;

        mainImg.on("load", function () {
            mainImg.height("auto").width("auto");
            // 画像の表示
            mainImg.fadeIn(fadeInTime, function () {
                // 表示完了(ロード終了)
                isLoading = false;
            });
            return false;
        });

        //次へ・前へ イベント
        $(".room-nav-controls", element)
            // 次へ イベント
            .find(".next")
            .click(function () {
                var changeIndex = 0;
                var count = $imageThumnail.find(".selectedThumbnail").closest(".tab_wrap").find("a").length;
                var index = $imageThumnail.find(".selectedThumbnail").closest(".tab_wrap").find("a").index($imageThumnail.find(".selectedThumbnail"));
                if (index >= count - 1) {
                    return false;
                }
                changeIndex = index + 1;

                // 次へボタンの処理の際はサムネイルの処理を強制する。
                isLoading = false;
                $imageThumnail.find(".tab_wrap.shown a").eq(changeIndex).click();

                return false;
            })
            .end()
            // 前へ イベント
            .find(".prev")
            .click(function () {
                var changeIndex = 0;
                var index = $imageThumnail.find(".selectedThumbnail").closest(".tab_wrap").find("a").index($imageThumnail.find(".selectedThumbnail"));
                if (index == 0) {
                    return false;
                }
                changeIndex = index - 1;

                // 前へボタンの処理の際はサムネイルの処理を強制する。
                isLoading = false;
                $imageThumnail.find(".tab_wrap.shown a").eq(changeIndex).click();

                return false;
            });

        // サムネイルをマウスオーバー時に画像切り替え
        $(".room-viewer").each(function () {
            var set = $(this);
            var btn = set.find(".room-imagelist li a");
            var fadeEvent = null;
            // hover時
            $(btn)
                .hover(
                    function () {
                        var $hover_btn = $(this);
                        clearTimeout(fadeEvent);
                        if (mainImg.attr("src") != $hover_btn.attr("data-orig-src")) {
                            mainImg.stop(true, true).fadeOut(fadeOutTime, function () {
                                mainImg.attr("src", $hover_btn.attr("data-orig-src")).attr("alt", $hover_btn.find("img").attr("alt"));
                            });
                        }
                        $(this).children("img").stop().fadeTo("fast", 0.5);
                        return false;
                    },
                    function () {
                        if (!$(this).hasClass("selectedThumbnail")) {
                            fadeEvent = setTimeout(function () {
                                // 元のイメージを隠す
                                mainImg.stop(true, true).fadeOut(fadeOutTime, function () {
                                    // イメージの変更
                                    $thumnail = $(".room-imagelist", element).find(".selectedThumbnail");
                                    mainImg.attr("src", $thumnail.attr("data-orig-src")).attr("alt", $thumnail.find("img").attr("alt"));
                                });
                            }, 0);
                        }
                        $(this).children("img").stop().fadeTo("fast", 1);
                        return false;
                    }
                )
                //クリック時
                .click(function () {
                    // ロード中は変更しない
                    if (isLoading) return false;
                    var $link = $(this),
                        $img = $link.children("img");
                    // 選択されていたthumbnailを解除
                    $link.closest(".room-image-thumnail").find("li a.selectedThumbnail").removeClass("selectedThumbnail");
                    // thumbnailの選択
                    $link.addClass("selectedThumbnail");
                    // クリックされたthumbnailのIndexを取得
                    imageIndex = $(".room-imagelist a").index(this);
                    mainImg.data("index", imageIndex);

                    // 同じ画像は変更しない
                    if ($link.attr("data-orig-src") == mainImg.attr("src")) return false;

                    // ロード開始
                    isLoading = true;
                    // 元のイメージを隠す
                    mainImg.fadeOut(100, function () {
                        // イメージの変更
                        mainImg.attr("src", $link.attr("data-orig-src")).attr("alt", $img.attr("alt"));
                    });

                    return false;
                })
                .eq(0)
                .click();
        });
    });
});
